import Storage from '@common/Storage/Storage'

import type { IStorage } from './definitions'

// Ügyesedni LocalStorage
const storage: IStorage = new Storage('ugyesedni')

export default storage
